<template>
  <v-card class="account-section" v-if="user != null">
    <!--집금용 계좌-->
    <CollectionBnkAccount :collection="collection" :isUpdatable="isUpdatable" :user="user" v-if="isBnk"/>
    <CollectionWelcomeAccount :collection="collection" :isUpdatable="isUpdatable" :user="user" v-else-if="isWelcome"/>
    <CollectionBnkAccount :collection="collection" :isUpdatable="isUpdatable" :user="user" v-else/>
    <!--출금용 계좌-->
    <WithdrawalAccount :withdrawal="withdrawal" :withdrawBankCode="withdrawBankCode" :isUpdatable="isUpdatable" :user="user" @show-banks="showBanks"/>
  </v-card>
</template>
<script>
import AuthService from '@/service/auth/AuthService'
import contractsApi from '@/api/now/contractsApi'
// Components
import WithdrawalAccount from './BankAccounts/WithdrawalAccount'
import CollectionWelcomeAccount from './BankAccounts/CollectionWelcomeAccount'
import CollectionBnkAccount from './BankAccounts/CollectionBnkAccount'

export default {
  components: {
    WithdrawalAccount,
    CollectionWelcomeAccount,
    CollectionBnkAccount,
  },
  props: ['withdrawBankCode'],
  data() {
    return {
      user: {},
      withdrawal: {},
      collection: {},
      repayment: {},
      isUpdatable: false,
    }
  },
  created() {
    this.getUser()
  },
  methods: {
    getUser() {
      this.user = AuthService.getProfile()

      this.getIsUpdatable()

      // data에 계좌 정보 setting
      let accountNames = ['withdrawal', 'collection', 'repayment']
      accountNames.forEach(name => {
        let account = this.user[name + '_account']
        this[name] = Object.assign(this[name], account)
      })
    },
    getIsUpdatable() {
      return new Promise(async (resolve, reject) => {
        try {
          let { data } = await contractsApi.getCurrentContract()
          if (data && data.status && (['partially_started', 'started'].indexOf(data.status) >= 0)) {
            this.isUpdatable = false
          } else {
            this.isUpdatable = true
          }
          resolve(this.isUpdatable)
        } catch (e) {
          console.error(e, 'getCurrentContract')
          reject(e)
        }
      })
    },
    showBanks() {
      if (this.isUpdatable) {
        this.$emit('show-banks')
      }
    },
  },
  computed: {
    isBnk() {
      return this.collection.bank === '39'
    },
    isWelcome() {
      return this.collection.bank === '50'
    }
  }
}
</script>

<style lang="scss" scoped>
$default-blue-color: #1baaf1;
$btn-disable-background-color: #e3ecf6;
$gray-text-color: #727d8c;

.account-section {
  color: #333333;
  margin: 0 25px;
  margin-bottom: 20px;
  padding: 18px 25px;
  display: flex;
  flex-direction: column;

  input {
    width: calc(100% - 12px);
  }

}
</style>
